<div id="{{appName}}-app" class="feature-preview-dialog">
    <div id="body-wrapper" class="preview-body-wrapper">
        <div id="feature-preview-dialog-content" mat-dialog-title>
            <div class="row">
                <div class="col-md-12">
                    <span class="fa fa-close action-icons float-right ml-auto p-10" [ngClass]="{'close-icon':appName === 'lexus'}" (click)="close()"></span>
                </div>
            </div>
        </div>
        <div mat-dialog-content class="overflow-hidden d-flex justify-content-center">
            <div class="text-center">
                <div class="container-tile-block" *ngIf="featureInfo && featureInfo.length >0">
                    <div class="tile-block  stdWidth card-deck">
                        <div >
                            <app-breadcrumb [isPreviewMode]="true"></app-breadcrumb>
                        </div>
                        <app-tile [control]="feature" *ngFor="let feature of featureInfo" style="cursor:default;">
                        </app-tile>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>